import { useEffect, useState } from 'react';
import useReducedMotion from './useReducedMotion';

// Keep controlled overlays mounted through their exit, including their scroll lock.
export default function useMotionPresence(isOpen, duration = 200) {
  const reduced = useReducedMotion();
  const [retained, setRetained] = useState(isOpen);
  useEffect(() => {
    if (isOpen) {
      setRetained(true);
      return undefined;
    }
    if (reduced) {
      setRetained(false);
      return undefined;
    }
    const timer = window.setTimeout(() => setRetained(false), duration);
    return () => window.clearTimeout(timer);
  }, [isOpen, reduced, duration]);
  return { present: isOpen || (!reduced && retained), exiting: !isOpen };
}
